import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthModal } from "@/components/AuthModal";
import { PlannerModal } from "@/components/PlannerModal";
import { AuthCallback } from "@/components/AuthCallback";
import { ChatWidget } from "@/components/ChatWidget";
import { AdminGate } from "@/components/AdminGate";
import Home from "@/pages/Home";
import Travel from "@/pages/Travel";
import Fashion from "@/pages/Fashion";
import SelfCare from "@/pages/SelfCare";
import Lifestyle from "@/pages/Lifestyle";
import About from "@/pages/About";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Temu from "@/pages/Temu";
import Shein from "@/pages/Shein";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdmin = location.pathname === "/admin";
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/fashion" element={<Fashion />} />
        <Route path="/self-care" element={<SelfCare />} />
        <Route path="/lifestyle" element={<Lifestyle />} />
        <Route path="/about" element={<About />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/temu" element={<Temu />} />
        <Route path="/shein" element={<Shein />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <AuthModal />
      <PlannerModal />
      <AdminGate />
      {!isAdmin && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AppProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
